import { SideMenuOptionInterface } from '../../shared';

export const filterMenuByPermissions = (
  menu: SideMenuOptionInterface[],
  availableModules: string[]
): SideMenuOptionInterface[] =>
  menu
    .map((item) => {
      if (item.children) {
        const filteredChildren = item.children.filter(
          (child) => !child.permission || availableModules.includes(child.permission)
        );
        if (filteredChildren.length > 0) {
          return { ...item, children: filteredChildren };
        }
        return null;
      }

      if (!item.permission || availableModules.includes(item.permission)) {
        return item;
      }

      return null;
    })
    .filter(Boolean) as SideMenuOptionInterface[];
